import React, { useRef } from "react";
import { BsArrowDown,  } from 'react-icons/bs';

function Catelogs() {
  const cardsRef = useRef(null);

  const cardsRef1 = useRef(null);


  // Function to scroll to the cards section
  const handleScroll = () => {
    if (cardsRef.current) {
      cardsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleScroll1 = () => {
    if (cardsRef1.current) {
      cardsRef1.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  // Data for cards
  const cards = [
    {
      id: 1,
      title: "Jacquard Zebra Collection",
      description: "Experience the ultimate luxury and performance.",
      image: "images/vol1.png",
      pdf: "/images/SSG Jacquard Zebra.pdf",
    },
    {
      id: 2,
      title: "Third Wave",
      description: "Fast, stylish, and built for thrill-seekers.",
      image: "images/vol2.png",
      pdf: "/images/ThirdWave Jacquard Zebra.pdf",
    },
    {
      id: 3,
      title: "Volume 4",
      description: "Eco-friendly and futuristic driving experience.",
      image: "images/zebre3.png",
      pdf: "/images/Zebra Vol. 4  Catalogue-final.pdf",
    },
    
  ];

  const cards2 = [
    {
        id: 1,
        title2: "Roller Basic Collection",
        description2: "Experience the ultimate luxury and performance.",
        image2: "images/roller.png",
        pdf2: "/images/Roller Basic Catalogue .pdf",
      },
      {
        id: 2,
        title2: "Souvenir 2.0",
        description2: "Fast, stylish, and built for thrill-seekers.",
        image2: "images/roller1.png",
        pdf2: "/images/Souvenir 2.0  Roller Cataloguefinal.pdf",
      },
      {
        id: 3,
        title2: "Souvenir 3.0",
        description2: "A versatile range of classic roller models.",
        image2: "images/roller2.png",
        pdf2: "/images/Souvenir 3.0 Catalogue.pdf",
      },
  ];

  return (
    <div className=" ">
        {/* bg-gradient-to-r from-gray-600 to-gray-300 */}
      {/* Section One */}
      <div className="relative w-full h-screen bg-gray-200 overflow-hidden">
  <img 
    src="images/blindscatelagbg1.jpg" 
    alt="Zebra Blinds" 
    className="w-full h-full object-cover "
  />

  {/* Layer covering left half */}
  <div className="absolute inset-y-0 left-0 w-full xl:w-1/2 bg-black bg-opacity-60 flex flex-col justify-center md:px-10">
  <div className=" absolute xl:top-60">
    <h1 className="text-4xl md:text-7xl font-thin text-white  brightness-200  text-center">OUR CATALOGUES</h1>
    <h2 className="text-gray-300 text-xl md:text-2xl leading-relaxed mt-8 text-center xl:p-4">
      Explore our exclusive collection of Catalogue, featuring the latest designs and models.  
      From premium to modern innovations, find the perfect inspiration for your project.
    </h2>
    <div className="flex justify-center">
  {/* View More Button */}
  <button 
      onClick={handleScroll} 
      className="mt-6 w-40 md:w-52 bg-white uppercase text-black text-xl md:text-xl py-1 lg:py-2 px-5 hover:bg-gray-200 transition"
    >
     Explore
    </button>
</div>
    </div>

  
  </div>
</div>

<div className="">
      <div  ref={cardsRef} className=" text-black py-20 px-10 ">
  <p className="text-center text-4xl md:text-6xl mb-6">ZEBRA BLINDS CATALOGUES</p>
  <p className="text-gray-500 text-xl text-center mt-4 max-w-2xl mx-auto">
    From classic shades to advanced smart blinds, find inspiration in our carefully 
    curated catalogues designed for elegance and functionality.
  </p>
</div>

      {/* Vertical Cards Section */}
      <div className="md:mt-8 flex flex-col  md:flex-row justify-center gap-4 px-6 md:px-10 pb-20">
  {cards.map((card) => (
    <div key={card.id} className="flex flex-col items-center md:w-[400px]">
      {/* Card Image with Black Overlay & Button */}
      <div className="relative h-[430px] xl:h-[500px] w-full overflow-hidden">
        <img src={card.image} alt={card.title} className="w-full h-full object-contain" />

        {/* Black Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-40 flex justify-start items-end p-4">
          {/* Download PDF Button */}
          <a
            href={card.pdf}
            download
            className="bg-white text-black text-sm py-2 px-4 hover:bg-gray-300 transition flex items-center"
          >
            <span className="flex items-center">
              DOWNLOAD <BsArrowDown size={18} className="ml-2" />
            </span>
          </a>
        </div>
      </div>
      {/* Title & Description Below */}
      <div className="mt-4 text-center">
        <h3 className="text-xl font-semibold uppercase text-black">{card.title}</h3>
        <p className="text-lg mt-1 text-gray-700">{card.description}</p>
      </div>
    </div>
  ))}
</div>

</div>


<div className="h-full flex flex-col lg:flex-row  ">


  {/* Left Side - Black Background with Text */}
  <div className="lg:w-1/2 bg-[#1a0f0d] text-white flex flex-col   justify-center items-center ">
  <div>
  <h2 className="text-3xl md:text-6xl pb-20  text-center 2xl:text-left pt-12 text-white xl:pl-60  ">
      PREMIUM WOODEN <span className="text-left">COLLECTION </span>
    </h2>
    </div>

   <div className="flex flex-col md:gap-12 p-3 ">


    {/* Card Positioned Below Text */}
    <div className="relative w-full max-w-md   overflow-hidden ">
      <img src="images/venetian.jpg" alt="Wooden Venetian Blinds" className="h-64 w-full object-cover" />
      <div className="absolute bottom-0 left-0 bg-black bg-opacity-50 text-white px-4 py-1 pb-3 w-full">
        <h3 className="text-xl font-semibold">Wooden Venetian Blinds</h3>
        {/* <p className="text-sm">Click below to download the catalogue.</p> */}
        <a href="/images/SSG Bass Wood Catalogue.pdf" download className="mt-3 inline-block bg-white text-black text-sm py-2 px-4 hover:bg-gray-300 transition">
          DOWNLOAD
        </a>
      </div>
    </div>
    {/* <div className="mt- ">
      <p className="text-lg sm:text-xl max-w-sm ">
        <span className="font-bold text-xl">SSG Bass Wood Catalogue</span>
        <br />
        Explore our range of high-quality basswood models, perfect for both detailed and large-scale projects.
      </p>
    </div> */}

    <div className="relative z-10 mt-8 ">
      {/* Card Positioned Above Text */}
       {/* Text Positioned Below Card */}
      
      <div className="relative w-full max-w-md bg-white  overflow-hidden lg:mb-12">
        <img src="images/verticalcard.jpg" alt="Faux Wood Collection" className="h-64 w-full object-cover" />
        <div className="absolute bottom-0 left-0 bg-black bg-opacity-50 text-white px-4 py-1 w-full pb-3">
          <h3 className="text-xl font-semibold">Faux Wood Collection</h3>
          {/* <p className="text-sm">Click below to download the catalogue.</p> */}
          <a href="images/SSG Faux Wood Catalogue.pdf" download className="mt-3 inline-block bg-white text-black text-sm py-2 px-4 hover:bg-gray-300 transition">
            DOWNLOAD
          </a>
        </div>
      </div>
      {/* <div className=" flex justify-center ">
        <p className="text-white text-lg sm:text-xl  ">
          <span className="font-bold text-xl text-center">SSG Faux Wood Catalogue</span>
          <br />
          Browse our realistic faux wood models, offering the beauty of wood with added practicality.
        </p>
      </div> */}
     
    </div>
    </div>
  </div>

  {/* Right Side - Image Background with Card */}
  <div
    className="lg:w-1/2 flex flex-col justify-center items-center p-6  pt-3 md:p-10  relative"
    style={{
      backgroundImage: "url('images/illuminated.jpg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    {/* Overlay for Better Readability */}
    <div className="absolute inset-0 bg-black bg-opacity-70"></div>
    <div className="  max-w-2xl">
   <p className="text-white text-3xl md:text-5xl lg:text-4xl text-justify  lg:text-center font-thin brightness-200 md:leading-[55px]">Browse our realistic faux wood and Wooden Venetian models, offering the beauty of wood with added practicality. </p>

<p className="text-white text-3xl md:text-5xl lg:text-4xl font-thin text-justify lg:text-center brightness-200 md:leading-[55px] pt-6 md:mt-12">
Perfect for projects requiring a wood-like appearance without the complexities of real wood.
</p>
   </div>
   <div className="">
   <button  onClick={handleScroll1}  download className="inline-block brightness-200 mt-6 bg-white text-black text-lg py-2 md:py-3 px-4 hover:bg-gray-300 transition">
            Click For Next Collection
          </button>
    </div>
  </div>
  
</div>

 {/* Section two */}
<div  className=" text-black py-20 md:px-10  p-3">
  <p ref={cardsRef1}  className="text-center text-3xl md:text-6xl  ">ROLLER BLINDS CATALOGUES</p>
  <p className="text-gray-500 text-xl text-center mt-4 max-w-2xl mx-auto">
  Discover our premium selection of roller blinds with a wide variety of styles, colors, and fabrics. Whether you’re looking for functionality or design, our catalogues offer the perfect solutions for every space.
  </p>
</div>
      <div className="md:mt-8 flex flex-col md:flex-row justify-center gap-4 px-6 md:px-10 pb-20">
  {cards2.map((cards2) => (
    <div key={cards2.id} className="flex flex-col items-center md:w-[400px]">
      {/* Card Image with Black Overlay & Button */}
      <div className="relative h-[430px] xl:h-[500px] w-full overflow-hidden">
        <img src={cards2.image2} alt={cards2.title2} className="w-full h-full object-contain" />

        {/* Black Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-40 flex justify-center items-end p-4">
          {/* Download PDF Button */}
          <a
            href={cards2.pdf2}
            download
            className="bg-white text-black text-sm py-2 px-4 hover:bg-gray-300 transition flex items-center"
          >
            <span className="flex items-center">
              DOWNLOAD <BsArrowDown size={18} className="ml-2" />
            </span>
          </a>
        </div>
      </div>
      {/* Title & Description Below */}
      <div className="mt-4 text-center">
        <h3 className="text-xl font-semibold uppercase text-black">{cards2.title2}</h3>
        <p className="text-lg mt-1 text-gray-700">{cards2.description2}</p>
      </div>
    </div>
  ))}
</div>
      <section className="relative bg-cover bg-center py-24 " style={{ backgroundImage: "url('images/verticalcard.jpg') " }}>
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 container mx-auto text-center text-white px-6">
            <h2 className="text-3xl md:text-5xl mb-6">Want to know more Information about our Catalogues and Products? </h2>
            <div className=" flex justify-center">
            </div>
          
            <a
              href="/contactus"
              className="inline-block bg-gray-400 text-white  px-8 py-2 md:py-3 uppercase shadow-lg hover:bg-[#9e7f52] transition duration-300"
            >
              Contact Us
            </a>
          </div>
        </section>


    </div>
  );
}

export default Catelogs;


// import React, { useRef } from "react";
// import { BsArrowDown, BsArrowUpRight } from 'react-icons/bs';

// function Catelogs() {
//   const cardsRef = useRef(null);

//   const cardsRef1 = useRef(null);


//   // Function to scroll to the cards section
//   const handleScroll = () => {
//     if (cardsRef.current) {
//       cardsRef.current.scrollIntoView({ behavior: "smooth" });
//     }
//   };

//   const handleScroll1 = () => {
//     if (cardsRef1.current) {
//       cardsRef1.current.scrollIntoView({ behavior: "smooth" });
//     }
//   };
//   // Data for cards
//   const cards = [
//     {
//       id: 1,
//       title: "Jacquard Zebra Collection",
//       description: "Jacquard Zebra Collection – Luxurious design meets exceptional performance.",
//       image: "images/vol1.png",
//       pdf: "/images/SSGJacquard.pdf",
//     },
//     {
//       id: 2,
//       title: "Third Wave",
//       description: "Third Wave – A perfect blend of innovation, style, and performance.",
//       image: "images/vol2.png",
//       pdf: "images/ThirdWave Jacquard Zebra.pdf",
//     },
//     {
//       id: 3,
//       title: "Volume 4",
//       description: "Eco-friendly and innovative blinds for a modern living space..",
//       image: "images/zebre3.png",
//       pdf: "/images/electric_car.pdf",
//     },
    
//   ];

//   const cards2 = [
//     {
//         id: 1,
//         title2: "Roller Basic Collection",
//         description2: "Stylish and versatile roller blinds for a sleek, modern look.",
//         image2: "images/roller.png",
//         pdf2: "/images/Roller Basic Catalogue .pdf",
//       },
//       {
//         id: 2,
//         title2: "Souvenir 2.0",
//         description2: "Timeless elegance and functionality with Souvenir 2.0 blinds.",
//         image2: "images/roller1.png",
//         pdf2: "/images/sports_car.pdf",
//       },
//       {
//         id: 3,
//         title2: "Souvenir 3.0",
//         description2: "Enhanced style and performance with Souvenir 3.0 blinds.",
//         image2: "images/roller2.png",
//         pdf2: "/images/Souvenir 3.0 Catalogue.pdf",
//       },
//   ];

//   return (
//     <div className=" ">
//         {/* bg-gradient-to-r from-gray-600 to-gray-300 */}
//       {/* Section One */}
//       <div className="relative w-full h-screen bg-gray-200 overflow-hidden">
//   <img 
//     src="images/blindscatelagbg1.jpg" 
//     alt="Zebra Blinds" 
//     className="w-full h-full object-cover"
//   />

//   {/* Layer covering left half */}
//   <div className="absolute inset-y-0 left-0 w-full md:w-1/2 bg-black bg-opacity-60 flex flex-col justify-center items-center px-6 md:px-10 text-center">
//     <h1 className="text-3xl sm:text-3xl md:text-5xl lg:text-7xl font-thin text-white">
//       OUR CATALOGUES
//     </h1>
//     <h2 className="text-gray-300 text-lg sm:text-xl md:text-2xl leading-relaxed text-justify mt-4 md:mt-8">
//       Explore our exclusive collection of Catalogue, featuring the latest designs and models.  
//       From premium selections to modern innovations, find the perfect inspiration for your next project.
//     </h2>
//     <div className="flex justify-center">
//       {/* View More Button */}
//       <button 
//         onClick={handleScroll} 
//         className="mt-4 md:mt-6 w-44 sm:w-52 bg-white text-black text-lg sm:text-xl md:text-2xl py-2 sm:py-3 px-4 sm:px-5 hover:bg-gray-200 transition"
//       >
//         Explore
//       </button>
//     </div>
//   </div>
// </div>


// <div className="">
//       <div  ref={cardsRef} className=" text-black py-20 px-10 ">
//   <p className="text-center text-3xl md:text-6xl mb-6">ZEBRA BLINDS CATALOGUES</p>
//   <p className="text-gray-500 text-xl text-center mt-4 max-w-2xl mx-auto">
//     From classic shades to advanced smart blinds, find inspiration in our carefully 
//     curated catalogues designed for elegance and functionality.
//   </p>
// </div>

//       {/* Vertical Cards Section */}
//       <div className="mt-8 flex flex-col md:flex-row justify-center gap-4 px-3 lg:px-10 pb-20">
//   {cards.map((card) => (
//     <div key={card.id} className="relative h-[600px] md:w-[400px] overflow-hidden ">
//       {/* Card Image */}
//       <img src={card.image} alt={card.title} className="w-full h-full object-cover" />

//       {/* Text Overlay */}
//       <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-end p-4 text-white">
//         <h3 className="text-xl font-semibold uppercase">{card.title}</h3>
//         <p className="text-lg mt-1">{card.description}</p>

//         {/* Download PDF Button */}
//         <div className="flex">
//           <a
//             href={card.pdf} // Dynamically set PDF file per card
//             download
//             className="mt-3 bg-white text-black text-sm mb-2 py-2 px-4 hover:bg-gray-300 transition flex items-center"
//           >
//             <span className="flex items-center">
//               DOWNLOAD <BsArrowDown size={18} className="ml-2" />
//             </span>
//           </a>
//         </div>
//       </div>
//     </div>
//   ))}
// </div>

// </div>

// {/* jumble starts here */}
// {/* <div className="flex flex-col md:flex-row h-auto md:h-screen relative">
//   <div className="w-full md:w-1/2 bg-black h-full flex flex-col items-center justify-center p-6 relative">
//     <h2 className="absolute top-5 left-5 md:left-32 leading-tight text-white text-3xl sm:text-5xl md:text-7xl text-center md:text-left">
//       PREMIUM WOODEN<br /> COLLECTION
//     </h2>

//     <div className="w-full px-5 md:px-10 mt-24 md:mt-32">
//       <p className="text-white text-lg sm:text-xl max-w-md mx-auto md:mx-0 text-center md:text-left">
//         <span className="font-bold block text-center md:text-left">SSG Bass Wood Catalogue</span>
//         <br />
//         Explore our range of high-quality basswood models, perfect for both detailed and large-scale projects.
//       </p>
//     </div>

//     <div className="w-full px-5 md:px-10 mt-10">
//       <p className="text-white text-lg sm:text-xl max-w-md mx-auto md:mx-0 text-center md:text-left">
//         <span className="font-bold block text-center md:text-left">SSG Faux Wood Catalogue</span>
//         <br />
//         Browse our realistic faux wood models, offering the beauty of wood with added practicality.
//       </p>
//     </div>
//   </div>

//   <div className="w-full md:w-1/2">
//     <img src="images/illuminated.jpg" alt="Background" className="w-full h-full object-cover" />
//   </div>

//   <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col gap-6 w-full px-4">
//     <div className="overflow-hidden h-[250px] md:h-[300px] max-w-full md:max-w-3xl flex mx-auto">
//       <div className="relative w-full">
//         <img src="images/venetian.jpg" alt="Zebra Blinds" className="h-full w-full md:w-[500px] object-cover" />
//         <div className="absolute bottom-0 left-0 bg-black bg-opacity-40 text-white px-4 py-3 w-full">
//           <h3 className="text-xl md:text-2xl font-semibold">Wooden Venetian Blinds</h3>
//           <p className="text-gray-200 text-sm md:text-base">Click below to download the catalogues.</p>
//           <a
//             href="/images/Zebra_Blinds_Model_B.pdf"
//             download
//             className="mt-3 inline-block bg-white text-black text-sm py-2 px-4 hover:bg-gray-300 transition"
//           >
//             DOWNLOAD
//           </a>
//         </div>
//       </div>
//     </div>

//     <div className="overflow-hidden h-[250px] md:h-[300px] max-w-full md:max-w-3xl flex mx-auto">
//       <div className="relative w-full">
//         <img src="images/verticalcard.jpg" alt="Zebra Blinds" className="h-full w-full md:w-[500px] object-cover" />
//         <div className="absolute bottom-0 left-0 bg-black bg-opacity-40 text-white px-4 py-3 w-full">
//           <h3 className="text-xl md:text-2xl font-semibold">Faux Wood Collection</h3>
//           <p className="text-gray-200 text-sm md:text-base">Click below to download the catalogues.</p>
//           <a
//             href="/images/Zebra_Blinds_Model_B.pdf"
//             download
//             className="mt-3 inline-block bg-white text-black text-sm py-2 px-4 hover:bg-gray-300 transition"
//           >
//             DOWNLOAD
//           </a>
//         </div>
//       </div>
//     </div>
//   </div>
// </div> */}
// <div className="flex flex-col xl:flex-row min-h-screen relative">
//   {/* Left Side - Black Background */}
//   <div className="xl:w-1/2 w-full bg-black flex flex-col justify-center p-6 relative">
//     <h2 className="absolute top-8 text-center xl:text-left 2xl:left-32 left-6 text-white text-3xl md:text-5xl xl:text-6xl leading-[40px] md:leading-[60px] lg:leading-[70px]">
//       PREMIUM WOODEN COLLECTION
//     </h2>

//     {/* Catalog Text Sections */}
//     <div className=" flex flex-col justify-center lg:justify-start items-center xl:items-start px-2 2xl:px-10 space-y-10 md:space-y-20 lg:space-y-20 mt-32 md:mt-28  xl:mt-0">
//       <div className="text-white text-sm md:text-lg lg:text-xl max-w-sm text-justify relative z-10">
//         <p className="block text-center font-bold text-2xl mt-12">SSG Bass Wood Catalogue</p>
//         <p className="text-xl mt-4">
//         Explore our range of high-quality basswood models, perfect for both detailed and large-scale projects. Ideal for precision and easy customization.</p>
//       </div>

//       <div className="text-white text-sm md:text-lg lg:text-xl max-w-sm text-justify relative z-10">
//         <p className="block text-center font-bold text-2xl">SSG Faux Wood Catalogue</p>
//         <p className="text-xl mt-4">
//         Browse our realistic faux wood models, offering the beauty of wood with added practicality. Perfect for projects requiring a wood-like appearance without the complexities of real wood.</p>
//       </div>
//     </div>
//   </div>

//   {/* Right Side - Bigger Background Image */}
// <div className="relative w-full xl:w-1/2 h-screen">
//   <img src="images/illuminated.jpg" alt="Background" className="w-full h-full object-cover" />
// </div>

// {/* Cards Section */}
// <div className="absolute top-[55%] md:top-[45%] lg:top-[48%] xl:top-[11%] left-1/2 transform -translate-x-1/2 flex flex-col gap-20 md:gap-8 w-full px-4 lg:px-0 z-10">
//   {/* First Card */}
//   <div className="overflow-hidden h-[220px] md:h-[350px] w-[300px] md:w-[330px]  2xl:w-[400px] max-w-xl md:max-w-3xl flex mx-auto">
//     <div className="relative w-full">
//       <img src="images/venetian.jpg" alt="Wooden Venetian Blinds" className="h-full w-full object-cover" />
//       <div className="absolute bottom-0 left-0 bg-black bg-opacity-50 text-white px-4 py-3 w-full">
//         <h3 className="text-lg md:text-2xl font-semibold">Wooden Venetian Blinds</h3>
//         <p className="text-gray-200 leading-5 text-sm md:text-base">
//           Click below to download the catalogues and find the perfect models for your needs.
//         </p>
//         <div className="flex">
//           <a href="/images/SSG Bass Wood Catalogue.pdf" download className="mt-2 bg-white text-black text-xs md:text-sm py-2 px-4 hover:bg-gray-300 transition flex items-center">
//             <span className="flex items-center">
//               DOWNLOAD <BsArrowDown size={16} className="ml-2" />
//             </span>
//           </a>
//         </div>
//       </div>
//     </div>
//   </div>

//   {/* Second Card */}
//   <div className="overflow-hidden h-[220px] md:h-[350px] w-[300px] md:w-[350px] 2xl:w-[400px] max-w-xl md:max-w-3xl flex mx-auto">
//     <div className="relative w-full">
//       <img src="images/verticalcard.jpg" alt="Faux Wood Collection" className="h-full w-full object-cover" />
//       <div className="absolute bottom-0 left-0 bg-black bg-opacity-50 text-white px-4 py-3 w-full">
//         <h3 className="text-lg md:text-2xl font-semibold">Faux Wood Collection</h3>
//         <p className="text-gray-200 leading-5 text-sm md:text-base">
//           Click below to download the catalogues and find the perfect models for your needs.
//         </p>
//         <div className="flex">
//           <a href="/images/SSG Faux Wood Catalogue.pdf" download className="mt-2 bg-white text-black text-xs md:text-sm py-2 px-4 hover:bg-gray-300 transition flex items-center">
//             <span className="flex items-center">
//               DOWNLOAD <BsArrowDown size={16} className="ml-2" />
//             </span>
//           </a>
//         </div>
//       </div>
//     </div>
//   </div>
// </div>

// </div>
// {/* jumble ends here */}



//  {/* Section two */}
//  {/*  */}

//  <div className="text-black py-10 px-6 md:py-20 md:px-10">
//   {/* Heading */}
//   <p ref={cardsRef1} className="text-center text-3xl md:text-5xl lg:text-6xl  mb-6">
//     ROLLER BLINDS CATALOGUES
//   </p>

//   {/* Description */}
//   <p className="text-gray-500 text-lg md:text-xl text-center mt-4 max-w-2xl mx-auto">
//     Discover our premium selection of roller blinds with a wide variety of styles, colors, and fabrics. Whether you’re looking for functionality or design, our catalogues offer the perfect solutions for every space.
//   </p>
// </div>

//    {/* Roller Cards Section */}
//    <div className="mt-8 flex flex-col md:flex-row justify-center gap-4 px-3 md:px-10 pb-20">
//         {cards2.map((cards2) => (
//           <div key={cards2.id2} className="relative h-[600px] md:w-[400px] overflow-hidden ">
//             {/* Card Image */}
//             <img src={cards2.image2} alt={cards2.title2} className="w-full h-full object-contain" />

//             {/* Text Overlay */}
//             <div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col justify-end p-4 text-white">
//               <h3 className="text-2xl font-semibold mt-3">{cards2.title2}</h3>
//               <p className="text-md mt-1">{cards2.description2}</p>

//               {/* Download PDF Button */}
             
//           <div className="flex ">
//   <a
//     href="/images/Zebra_Blinds_Model_B.pdf"
//     download
//     className="mt-3 bg-white text-black text-sm mb-2 py-2 px-4 hover:bg-gray-300 transition flex items-center"
//   >
//     <span className="flex items-center">
//       DOWNLOAD <BsArrowDown size={18} className="ml-2" />
//     </span>
//   </a>
// </div>
//             </div>
//           </div>
//         ))}
//       </div>
//       <section className="relative bg-cover bg-center py-24 " style={{ backgroundImage: "url('images/verticalcard.jpg') " }}>
//           <div className="absolute inset-0 bg-black bg-opacity-50"></div>
//           <div className="relative z-10 container mx-auto text-center text-white px-6">
//             <h2 className="text-3xl md:text-5xl mb-6">Ready to know Information or Inquiries about our Catalogues and Products? </h2>
//             <div className=" flex justify-center">
//             </div>
//             <a
//               href="/contactus"
//               className="inline-block bg-gray-400 text-white font-semibold font-mono px-8 py-3 uppercase shadow-lg hover:bg-[#9e7f52] transition duration-300"
//             >
//               Contact Us
//             </a>
//           </div>
//         </section>
//     </div>
//   );
// }

// export default Catelogs;


// import React, { useRef } from "react";
// import { BsArrowDown, BsArrowUpRight } from 'react-icons/bs';

// function Catelogs() {
//   const cardsRef = useRef(null);

//   const cardsRef1 = useRef(null);


//   // Function to scroll to the cards section
//   const handleScroll = () => {
//     if (cardsRef.current) {
//       cardsRef.current.scrollIntoView({ behavior: "smooth" });
//     }
//   };

//   const handleScroll1 = () => {
//     if (cardsRef1.current) {
//       cardsRef1.current.scrollIntoView({ behavior: "smooth" });
//     }
//   };
//   // Data for cards
//   const cards = [
//     {
//       id: 1,
//       title: "Jacquard Zebra Collection",
//       description: "Experience the ultimate luxury and performance.",
//       image: "images/vol1.png",
//       pdf: "/images/luxury_car.pdf",
//     },
//     {
//       id: 2,
//       title: "Third Wave",
//       description: "Fast, stylish, and built for thrill-seekers.",
//       image: "images/vol2.png",
//       pdf: "/images/sports_car.pdf",
//     },
//     {
//       id: 3,
//       title: "Volume 4",
//       description: "Eco-friendly and futuristic driving experience.",
//       image: "images/zebre3.png",
//       pdf: "/images/electric_car.pdf",
//     },
    
//   ];

//   const cards2 = [
//     {
//         id: 1,
//         title2: "Roller Basic Collection",
//         description2: "Experience the ultimate luxury and performance.",
//         image2: "images/roller.png",
//         pdf2: "/images/luxury_car.pdf",
//       },
//       {
//         id: 2,
//         title2: "Souvenir 2.0",
//         description2: "Fast, stylish, and built for thrill-seekers.",
//         image2: "images/roller1.png",
//         pdf2: "/images/sports_car.pdf",
//       },
//       {
//         id: 3,
//         title2: "Souvenir 3.0",
//         description2: "A versatile range of classic roller models, designed for simplicity and efficiency.",
//         image2: "images/roller2.png",
//         pdf2: "/images/electric_car.pdf",
//       },
//   ];

//   return (
//     <div className=" ">
//         {/* bg-gradient-to-r from-gray-600 to-gray-300 */}
//       {/* Section One */}
//       <div className="relative w-full h-screen bg-gray-200 overflow-hidden">
//   <img 
//     src="images/blindscatelagbg1.jpg" 
//     alt="Zebra Blinds" 
//     className="w-full h-full object-cover "
//   />

//   {/* Layer covering left half */}
//   <div className="absolute inset-y-0 left-0 w-1/2 bg-black bg-opacity-60 flex flex-col justify-center md:px-10">
//     <h1 className="text-3xl md:text-7xl font-thin text-white text-center">OUR CATALOGUES</h1>
//     <h2 className="text-gray-300 text-2xl leading-relaxed mt-8 text-center">
//       Explore our exclusive collection of Catalogue, featuring the latest designs and models.  
//       From premium selections to modern innovations, find the perfect inspiration for your next project.
//     </h2>
// <div className="flex justify-center">
//   {/* View More Button */}
//   <button 
//       onClick={handleScroll} 
//       className="mt-6 w-52 bg-white text-black text-2xl  py-3 px-5 hover:bg-gray-200 transition"
//     >
//      Explore
//     </button>
// </div>
  
//   </div>
// </div>

// <div className="">
//       <div  ref={cardsRef} className=" text-black py-20 px-10 ">
//   <p className="text-center text-4xl md:text-6xl mb-6">ZEBRA BLINDS CATALOGUES</p>
//   <p className="text-gray-500 text-xl text-center mt-4 max-w-2xl mx-auto">
//     From classic shades to advanced smart blinds, find inspiration in our carefully 
//     curated catalogues designed for elegance and functionality.
//   </p>
// </div>

//       {/* Vertical Cards Section */}
//       <div className="mt-8 flex flex-col md:flex-row justify-center gap-4 px-3 md:px-10 pb-20">
//         {cards.map((card) => (
//           <div key={card.id} className="relative h-[600px] md:w-[400px] overflow-hidden ">
//             {/* Card Image */}
//             <img src={card.image} alt={card.title} className="w-full h-full object-cover" />

//             {/* Text Overlay */}
//             <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-end p-4 text-white">
//               <h3 className="text-xl font-semibold uppercase ">{card.title}</h3>
//               <p className="text-lg mt-1">{card.description}</p>

//               {/* Download PDF Button */}
//               <div className="flex ">
//   <a
//     href="/images/Zebra_Blinds_Model_B.pdf"
//     download
//     className="mt-3 bg-white text-black text-sm  mb-2 py-2 px-4 hover:bg-gray-300 transition flex items-center"
//   >
//     <span className="flex items-center">
//     DOWNLOAD <BsArrowDown size={18} className="ml-2" />
//     </span>
//   </a>
// </div>
//             </div>
//           </div>
//         ))}
//       </div>
// </div>


// <div className="flex h-screen relative">
//   {/* Left Side - Black Background */}
 

//   <div className="w-1/2 bg-black h-full flex items-center justify-center p-3 relative">
//   {/* Top-left positioned title */}
//   <h2 className="absolute top-5 lg:left-32 leading-[80px] text-white text-7xl ">
//     PREMIUM WOODEN<br/> COLLECTION
//   </h2>

// <div>
// <div className="text-black py-10 px-10">
//  {/* Centered paragraph content */}
//  <p className="text-white text-xl max-w-md absolute top-1/4 left-32   text-justify">
    
//     <p className=" text-center font-bold">SSG Bass Wood Catalogue</p>
    
//     <br />
//     Explore our range of high-quality basswood models, perfect for both detailed and large-scale projects. Ideal for precision and easy customization.
//   </p>
// </div>
    
// <div>
//  {/* Centered paragraph content */}
//  <p className="text-white text-xl max-w-md absolute bottom-1/4 left-32   text-justify">
   
//     <p className=" text-center pt-32 font-bold">SSG Faux Wood Catalogue</p>
//     <br />
//     Browse our realistic faux wood models, offering the beauty of wood with added practicality. Perfect for projects requiring a wood-like appearance without the complexities of real wood.
//   </p>
// </div>
// </div>
 
// </div>



//   {/* Right Side - Image Background */}
//   <div className="w-1/2">
//     <img src="images/illuminated.jpg" alt="Background" className="w-full h-full object-cover" />
//   </div>

//   {/* Cards - Centered with Half on Each Background */}
//   <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col gap-8">
//     {/* First Card */}
//     <div className=" overflow-hidden h-[300px] max-w-3xl flex">
//       <div className="relative w-full">
//         <img src="images/venetian.jpg" alt="Zebra Blinds" className="h-[300px] w-[500px] object-cover" />
//         <div className="absolute bottom-0 left-0 bg-black bg-opacity-40 text-white px-2 w-full">
//           <h3 className="text-2xl font-semibold">Wooden Venetian Blinds</h3>
//           <p className="text-gray-200 leading-5">Click below to download the catalogues and find the perfect models for your needs.</p>
//           <div className="flex ">
//   <a
//     href="/images/Zebra_Blinds_Model_B.pdf"
//     download
//     className="mt-3 bg-white text-black text-sm  mb-2 py-2 px-4 hover:bg-gray-300 transition flex items-center"
//   >
//     <span className="flex items-center">
//     DOWNLOAD <BsArrowDown size={18} className="ml-2" />
//     </span>
//   </a>
// </div>
//         </div>
//       </div>
//     </div>

//     {/* Second Card */}
//     <div className=" overflow-hidden h-[300px] max-w-3xl flex">
//       <div className="relative w-full">
//         <img src="images/verticalcard.jpg" alt="Zebra Blinds" className="h-[300px] w-[500px] object-cover" />
//         <div className="absolute bottom-0 left-0 bg-black bg-opacity-40 text-white px-2   w-full">
//           <h3 className="text-2xl font-semibold">Faux Wood Collection</h3>
//           <p className="text-gray-200 leading-5">Click below to download the catalogues and find the perfect models for your needs.</p>

//           <div className="flex ">
//   <a
//     href="/images/Zebra_Blinds_Model_B.pdf"
//     download
//     className="mt-3 bg-white text-black text-sm mb-2 py-2 px-4 hover:bg-gray-300 transition flex items-center"
//   >
//     <span className="flex items-center">
//       DOWNLOAD <BsArrowDown size={18} className="ml-2" />
//     </span>
//   </a>
// </div>

//         </div>
//       </div>
//     </div>
//   </div>
// </div>



//  {/* Section two */}
//  {/*  */}

// <div  className=" text-black py-20 px-10 ">
//   <p ref={cardsRef1}  className="text-center text-6xl  mb-6">ROLLER BLINDS CATALOGUES</p>
//   <p className="text-gray-500 text-xl text-center mt-4 max-w-2xl mx-auto">
//   Discover our premium selection of roller blinds with a wide variety of styles, colors, and fabrics. Whether you’re looking for functionality or design, our catalogues offer the perfect solutions for every space.
//   </p>
// </div>
//    {/* Roller Cards Section */}
//    <div className="mt-8 flex flex-col md:flex-row justify-center gap-4 px-3 md:px-10 pb-20">
//         {cards2.map((cards2) => (
//           <div key={cards2.id2} className="relative h-[600px] md:w-[400px] overflow-hidden ">
//             {/* Card Image */}
//             <img src={cards2.image2} alt={cards2.title2} className="w-full h-full object-contain" />

//             {/* Text Overlay */}
//             <div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col justify-end p-4 text-white">
//               <h3 className="text-2xl font-semibold mt-3">{cards2.title2}</h3>
//               <p className="text-md mt-1">{cards2.description2}</p>

//               {/* Download PDF Button */}
             
//           <div className="flex ">
//   <a
//     href="/images/Zebra_Blinds_Model_B.pdf"
//     download
//     className="mt-3 bg-white text-black text-sm mb-2 py-2 px-4 hover:bg-gray-300 transition flex items-center"
//   >
//     <span className="flex items-center">
//       DOWNLOAD <BsArrowDown size={18} className="ml-2" />
//     </span>
//   </a>
// </div>
//             </div>
//           </div>
//         ))}
//       </div>
//       <section className="relative bg-cover bg-center py-24 " style={{ backgroundImage: "url('images/verticalcard.jpg') " }}>
//           <div className="absolute inset-0 bg-black bg-opacity-50"></div>
//           <div className="relative z-10 container mx-auto text-center text-white px-6">
//             <h2 className="text-4xl md:text-5xl mb-6">Ready to know Information or Inquiries about our Catalogues and Products? </h2>
//             <div className=" flex justify-center">
//             </div>
          
//             <a
//               href="/contact"
//               className="inline-block bg-gray-400 text-white font-semibold font-mono px-8 py-3 uppercase shadow-lg hover:bg-[#9e7f52] transition duration-300"
//             >
//               Contact Us
//             </a>
//           </div>
//         </section>


//     </div>
//   );
// }

// export default Catelogs;
